import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';

export class SelectOption{
  value: any;
  text:any;
}

@Component({
  selector: 'teiasoft-list',
  templateUrl: './teiasoft-list.component.html',
  styleUrls: ['./teiasoft-list.component.scss']
})
export class TeiasoftListComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() labelText: string = "";
  @Input() isRequired: boolean = false;
  @Input() disabled: boolean = false;
  @Input() noMargin: boolean = false;
  @Input() noMinWidth: boolean = false;
  @Input() isValid: boolean = true;
  @Input() isMobile: boolean = false;
  @Input() value: string = "";
  @Input() optionsList:SelectOption[] = new Array();

  @Output() onSelect: EventEmitter<string> = new EventEmitter();

  selectId: string = "";
  optionsListId: string = "";
  optOpened: boolean = false;
  selectedOptions: SelectOption[] = new Array();
  private readonly bodyClickListener: EventListener;

  constructor(){
    this.bodyClickListener = (evt: Event) => this.onBodyClick(evt);
    document.body.addEventListener('click', this.bodyClickListener, true);
  }

  ngOnInit(): void {
    this.manageSelectListId();
    this.manageSelectOptCntId();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["optionsList"]){
      this.optionsList = new Array();
      this.optionsList = changes["optionsList"].currentValue;
      this.selectedOptions = new Array();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.setOptionCntDimension();
    },250);
  }

  ngOnDestroy(): void {
    document.body.removeEventListener('click', this.bodyClickListener, true);
    this.removeIdFromSessionStorage("TL-INPUT-LIST", this.selectId);
    this.removeIdFromSessionStorage("TL-INPUT-OPTION-LIST", this.optionsListId);
  }

  private onBodyClick(evt: Event): void {
    if (!this.optOpened) {
      return;
    }

    const target = evt.target;
    if (!(target instanceof Element)) {
      return;
    }

    const clickedInsideList = this.isElementInsideList(target);
    const isToggleIcon = target.classList.contains('ico-list') || target.className === 'fal fa-ellipsis ico-list';

    if (!clickedInsideList && !isToggleIcon) {
      this.onClickOpenList();
    }
  }

  private isElementInsideList(target: Element): boolean {
    if (!this.selectId && !this.optionsListId) {
      return false;
    }

    return Boolean(
      target.closest(`#${this.selectId}`) ||
      target.closest(`#${this.optionsListId}`)
    );
  }

  setOptionCntDimension(){
    const _cnt = document.getElementById(this.selectId);
    const _optCnt =  document.getElementById(this.optionsListId);
    let _w: number = _cnt!.clientWidth - (window.innerWidth*0.0035);
    _optCnt!.style.width = _w + "px"; //.setAttribute("style","width:" + _w + "px !important"); // calc(181px - 0.35vw) !important;
    //_optCnt!.setAttribute("style","display:none");
  }

  manageSelectListId(){
    let _list: string[] = new Array();
    if (sessionStorage.getItem("TL-INPUT-LIST")){
      _list = sessionStorage.getItem("TL-INPUT-LIST")!.split(",");
      if (_list.length == 999999){
        _list = new Array();
        sessionStorage.removeItem("TL-INPUT-LIST");
      }
    }
    let x = this.getRandomInt(0,999999);
    if (_list && _list.length > 0){
      while (_list.findIndex(t => t == "TL_" + x.toString()) != -1){
        let x = this.getRandomInt(0,999999);
        if (_list.findIndex(t => t == "TL_" + x.toString()) == -1) break;
      }
    } else {
      _list = new Array();
    }
    _list.push("TL_" + x.toString());
    sessionStorage.setItem("TL-INPUT-LIST", _list.join(","));
    this.selectId = "TL_" + x.toString();
  }

  manageSelectOptCntId(){
    let _list: string[] = new Array();
    if (sessionStorage.getItem("TL-INPUT-OPTION-LIST")){
      _list = sessionStorage.getItem("TL-INPUT-OPTION-LIST")!.split(",");
      if (_list.length == 999999){
        _list = new Array();
        sessionStorage.removeItem("TL-INPUT-OPTION-LIST");
      }
    }
    let x = this.getRandomInt(0,999999);
    if (_list && _list.length > 0){
      while (_list.findIndex(t => t == "TLOPT_" + x.toString()) == -1){
        let x = this.getRandomInt(0,999999);
        if (_list.findIndex(t => t == "TLOPT_" + x.toString()) == -1) break;
      }
    } else {
      _list = new Array();
    }
    _list.push("TLOPT_" + x.toString());
    sessionStorage.setItem("TL-INPUT-OPTION-LIST", _list.join(","));
    this.optionsListId = "TLOPT_" + x.toString();
  }


  getRandomInt(min: number, max: number): number {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  imSelected(value:string): boolean{
    if (this.selectedOptions && this.selectedOptions.length > 0){
      return this.selectedOptions.findIndex(x => x.value == value) != -1;
    }
    return false;
  }

  /* EVENTS */
  onClickOpenList(){
    if (this.disabled) return;
    this.optOpened = !this.optOpened;
    if (this.optOpened)
      document.getElementById(this.optionsListId)!.style.display="block";
    else
      document.getElementById(this.optionsListId)!.style.display="none";
  }

  selectThis(evt: any, opt:SelectOption){
    let _i: number = -1;
    if (this.selectedOptions.length > 0){
      _i = this.selectedOptions.findIndex(x => x.value == opt.value);
    }
    
    if (_i == -1)
      this.selectedOptions.push(opt);
    else
      this.selectedOptions.splice(_i, 1);

    this.value = '';
    let _valueToEmit: string = "";
    for (var x=0; x < this.selectedOptions.length; x++){
      this.value = this.value + this.selectedOptions[x].text + (x < this.selectedOptions.length-1 ? ',' : '');
      _valueToEmit = _valueToEmit + this.selectedOptions[x].value + (x < this.selectedOptions.length-1 ? ',' : '');
    }

    this.onSelect.emit(_valueToEmit);
  }

  private removeIdFromSessionStorage(storageKey: string, id: string): void {
    if (!id) {
      return;
    }

    const stored = sessionStorage.getItem(storageKey);
    if (!stored) {
      return;
    }

    const updated = stored.split(',').filter(item => item && item !== id);
    if (updated.length > 0) {
      sessionStorage.setItem(storageKey, updated.join(','));
    } else {
      sessionStorage.removeItem(storageKey);
    }
  }
}
